export const SendInvitation: {
  OWN: 'OWN'
  ALL: 'ALL'
  NOTOWN: 'NOTOWN'
} = {
  OWN: 'OWN',
  ALL: 'ALL',
  NOTOWN: 'NOTOWN'
}
type SendInvitation = typeof SendInvitation[keyof typeof SendInvitation]

export interface Staff {
  id?: number
  name: string
  email: string
  phone: string
  programOffice: string
  jobTitle: string
  staff_type: StaffType
}

export interface ProgramOffice {
  id?: number
  title: string
  acronym: string
  levelOneApprover: LevelOneApprover[]
  status: string
}

export interface LevelOneApprover {
  id: number;
  name: string;
  email: string;
}

export enum StaffType {
  PRESENTERS = 'PRESENTER',
  MODERATORS = 'MODERATOR',
  SUPPORT_STAFF = 'SUPPORT_STAFF'
}

export const EventStatus: {
  SAVED: 'SAVED'
  REJECTED: 'REJECTED'
  APPROVAL1: 'APPROVAL1'
  APPROVAL2: 'APPROVAL2'
  APPROVAL3: 'APPROVAL3'
  APPROVED: 'APPROVED'
  BLOCKED: 'BLOCKED'
  CANCELLED: 'CANCELLED'
} = {
  SAVED: 'SAVED',
  REJECTED: 'REJECTED',
  APPROVAL1: 'APPROVAL1',
  APPROVAL2: 'APPROVAL2',
  APPROVAL3: 'APPROVAL3',
  APPROVED: 'APPROVED',
  BLOCKED: 'BLOCKED',
  CANCELLED: 'CANCELLED'
}
export type EventStatus = typeof EventStatus[keyof typeof EventStatus]

export const VersionHistoryStatus: {
  SAVED: 'SAVED'
  REJECTED: 'REJECTED'
  APPROVAL1: 'APPROVAL1'
  APPROVAL2: 'APPROVAL2'
  APPROVAL3: 'APPROVAL3'
  APPROVED: 'APPROVED'
  BLOCKED: 'BLOCKED'
  RELEASED: 'RELEASED'
  UNLOCKED: 'UNLOCKED'
  CANCELLED: 'CANCELLED'
} = {
  SAVED: 'SAVED',
  REJECTED: 'REJECTED',
  APPROVAL1: 'APPROVAL1',
  APPROVAL2: 'APPROVAL2',
  APPROVAL3: 'APPROVAL3',
  APPROVED: 'APPROVED',
  BLOCKED: 'BLOCKED',
  RELEASED: 'RELEASED',
  UNLOCKED: 'UNLOCKED',
  CANCELLED: 'CANCELLED'
}
export type VersionHistoryStatus = typeof VersionHistoryStatus[keyof typeof VersionHistoryStatus]

export interface DateTimeInput {
  duration?: number
  liveBookingDate?: string
  dryBookingDate?: string
  audience: number
  category: string
}

export interface PublicationDateInput {
  publicationDate: Date
}

export interface BookingInput {
  liveDuration: number
  liveBookingDate: string
  liveStartTime: number
  dryDuration: number
  dryBookingDate: string
  dryStartTime: number
  audience: number
}

export interface BlockInput {
  startDate: string
  endDate: string
  startTime: number
  endTime: number
  roomType: string
}

export const Role: {
  REQUESTER: 'REQUESTER'
  APPROVER: 'APPROVER'
  EDITOR: 'EDITOR'
  ADMIN: 'ADMIN'
} = {
  REQUESTER: 'REQUESTER',
  APPROVER: 'APPROVER',
  EDITOR: 'EDITOR',
  ADMIN: 'ADMIN'
}
export type Role = typeof Role[keyof typeof Role]

export const SubRole = {
  PRIMARY: 'PRIMARY',
  ALTERNATE: 'ALTERNATE'
}
export type SubRole = typeof SubRole[keyof typeof SubRole]

export const ApprovalStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED'
}
export type ApprovalStatus = typeof ApprovalStatus[keyof typeof ApprovalStatus]

export const ProgramOfficeStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
}
export type ProgramOfficeStatus =
  typeof ProgramOfficeStatus[keyof typeof ProgramOfficeStatus]

export enum BookingCategory {
  LIVE = 'live',
  DRY = 'dry'
}

export interface RoomBooking {
  id: number;
  date: number;
  startTime: number;
  endTime: number;
  category: string;
}

export interface EventCloseout {
  eventId: number;
  files: null | string[];
  highlightsActionItems: string;
  id: number;
  numberOfAttendees: number;
  numberOfRegistrants: number;
  participantRatingsSummary: string;
}

export interface Event {
  id: number;
  title: string;
  summary: string;
  description: string;
  creater: { id: number; firstName: string; lastName: string; email?: string };
  createrId: number;
  staff: Staff[];
  overHundredParticipants: boolean;
  invitationDistributionList: string;
  sendInvitation: string;
  invitationNotes: string;
  additionalRequest: string;
  logisticNeed: string;
  publicOrPrivate: string;
  supportNeeded: string;
  status: string;
  date: string; //TODO: can remove once we remove ViewAndEdit.tsx
  time: number;  //TODO: can remove once we remove ViewAndEdit.tsx
  eventCloseout: EventCloseout | null;
  eventType: string;
  otherApproverEmail: string;
  otherApproverName: string;
  roomBooking: RoomBooking[];
  programOfficeId: number | null;
  levelOneApproverId: number | null;
  programOffice: ProgramOffice | null;
  levelOneApprover: LevelOneApprover | null;
  seriesId: number;
  featuresTranscription: string;
  featuresScript: string;
  tbd_presenters: number;
  tbd_moderators: number;
  tbd_supportstaff: number;
  publicationDate: Date | null;
  updatedAt: Date;
  createdAt: Date;
  latestApprovers?: {
    approver1: string;
    approver2: string;
    approver3: string;
  };
}

export enum EventType {
  WEBINAR = 'Webinar',
  WEBCAST = 'Webcast',
  PODCAST = 'Podcast',
  BLOCKED = 'Blocked',
  SERIES  = 'Series'
}

export enum RoomType {
  smallRoom = 'Small Room',
  largeRoom = 'Large Room',
  bothSmallRooms = 'Both Small Rooms',
  allRooms = 'All Rooms'
}

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  subRole: string;
  approverLevel: number;
  approvalStatus: string;
  programOffice: ProgramOffice;
  events: number;
  approvalEvents: number;
  createdAt: string;
}

export interface VersionHistory {
  id: number;
  user: User;
  status: string;
  changes: { field: string; description: string }[];
  createdAt: string;
}

export interface EventComment {
  id: number;
  eventId: number;
  user: User;
  message: string;
  createdAt: string;
}